/**
 *
 *  You can modify and use this source freely
 *  only for the development of application related Live2D.
 *
 *  (c) Live2D Inc. All rights reserved.
 */
import { getContext, getV2File, getV2Path } from "./LAppDefine"
import { CubismJson } from '../v2/framework/utils/cubismjson'
import { db } from "../lib/DbCache";
import { Live2dWebSDK } from '../lib/live2dWebSDK'

let requestCache = {};

export class PlatformManager {
    /**
     * PlatformManager # loadBytes()
     * @param path 
     */
    public async loadBytes(path: string, token?: string): Promise<ArrayBuffer> {
        // 获取当前model的名字
        let fileKey = getV2Path(path);
        let fileName = getV2File(path);
        // Cache 相同的请求，减少请求数量
        let rsp = await db.mocJson.where({ key: fileKey, name: fileName }).first();
        if (rsp) {
            return rsp.value;
        } else {
            let request: Response;
            if (token) {
                request = await fetch(path, {
                    headers: new Headers({
                        'Authorization': `Bearer ${token}`,
                    })
                });
            } else {
                request = await fetch(path);
            }
            let rsp = await request.arrayBuffer();
            switch (request.status) {
                case 200:
                    db.mocJson.put({ key: fileKey, name: fileName, value: rsp });
                    return rsp;
                default:
                    console.error("Failed to load (" + request.status + ") : " + path);
                    return null!;
            }
        }
    }

    /**
     * 返回路径对应的内容（字符串类型）
     * @param path 
     * @param callback 
     */
    public async loadString(path: string, token?: string): Promise<string> {
        let buf = await this.loadBytes(path, token);
        let arrayStr = CubismJson.arrayBufferToString(buf);
        return arrayStr;
    }

    public loadLive2DModel(path: string, callback: (model: any) => void, token?: string) {
        this.loadBytes(path, token).then((buf) => {
            var model = (<any>window).Live2DModelWebGL.loadModel(buf);
            callback(model);
        });
    }

    //============================================================
    //    PlatformManager # loadTexture()
    //============================================================
    public loadTexture(model/*ALive2DModel*/, no: number, path: string, callback) {
        // load textures
        var loadedImage = new Image();
        loadedImage.crossOrigin = 'Anonymous';
        loadedImage.src = path;

        var thisRef = this;
        loadedImage.onload = function () {
            // create texture
            if ((this as HTMLImageElement).complete) {
                var gl = getContext();
                var texture = gl.createTexture();
                if (!texture) { console.error("Failed to generate gl texture name."); return -1; }

                if (model.isPremultipliedAlpha() == false) {
                    // 乗算済アルファテクスチャ以外の場合
                    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 1);
                }
                gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
                gl.activeTexture(gl.TEXTURE0);
                gl.bindTexture(gl.TEXTURE_2D, texture);
                gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA,
                    gl.UNSIGNED_BYTE, loadedImage);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
                gl.generateMipmap(gl.TEXTURE_2D);



                model.setTexture(no, texture);

                // テクスチャオブジェクトを解放
                texture = null;
            } else {
                console.log("材质图片加载失败, 请刷新页面后重试");
            }
            if (typeof callback == "function") callback();
        };

        loadedImage.onerror = function () {
            console.error("Failed to load image : " + path);
        }
    }


    //============================================================
    //    PlatformManager # parseFromBytes(buf)

    //============================================================
    public jsonParseFromBytes(buf) {

        var jsonStr;



        var bomCode = new Uint8Array(buf, 0, 3);
        if (bomCode[0] == 239 && bomCode[1] == 187 && bomCode[2] == 191) {
            jsonStr = String.fromCharCode.apply(null, new Uint8Array(buf, 3));
        } else {
            jsonStr = String.fromCharCode.apply(null, new Uint8Array(buf));
        }

        var jsonObj = JSON.parse(jsonStr);

        return jsonObj;
    }


    //============================================================
    //    PlatformManager # log()
    //============================================================
    public log(txt: string) {
        //console.log(txt);
    }


}